import {
  AccordionDetails,
  Stack,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@mui/material';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useVarietiesByCustomer } from '../../../services/entities/hooks/useVarietiesByCustomer';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { CustomerDropdown } from '../../commonUI/dropdowns/CustomerDropdown';
import { ExpandableMenu } from '../../commonUI/Menu/ExpandableMenu';
import { MenuPaper } from '../../commonUI/Menu/MenuPaper';
import {
  selectCurrCustomerID,
  setCurrCustomerByID,
} from '../../select/selectSlice';
import { SettingsHeaderCell } from '../components/SettingsTableHeaderCell';
import { StageTableRow } from './components/StageTableRow';
export const VarietySettings = () => {
  const customerId = useAppSelector(selectCurrCustomerID);
  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const setCustomer = (id: string) => {
    dispatch(setCurrCustomerByID(id));
  };

  const { varieties } = useVarietiesByCustomer(customerId);

  const [expandedVariety, setExpandedVariety] = useState('');
  const handleExpandedChange = (varietyId: string) => {
    return (_event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpandedVariety(newExpanded ? varietyId : '');
    };
  };

  const varietyList = varieties?.map((variety) => {
    const expanded = variety.id === expandedVariety;

    return (
      <ExpandableMenu
        title={variety.name}
        key={variety.id}
        expanded={expanded}
        onChange={handleExpandedChange(variety.id)}
      >
        <AccordionDetails>
          <Table>
            <TableHead>
              <TableRow>
                <SettingsHeaderCell sx={{ width: '20%' }}>
                  {t('Stage')}
                </SettingsHeaderCell>
                <SettingsHeaderCell>{t('Variations')}</SettingsHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {variety.stages?.map((stage) => (
                <StageTableRow key={stage.id} stage={stage} />
              ))}
            </TableBody>
          </Table>
        </AccordionDetails>
      </ExpandableMenu>
    );
  });

  return (
    <Stack spacing={8}>
      <CustomerDropdown value={customerId} onChange={setCustomer} />
      <MenuPaper>{varietyList}</MenuPaper>
    </Stack>
  );
};
